<template>
  <q-layout view="lhh LpR lff">
    <q-page-container>
      <q-page padding>
        <div class="row justify-between">
          <q-btn class="justify-center q-ma-xs q-pr-md" ripple dense flat color="black" to="/">
            <q-icon name='arrow_left' style="font-size:2.5em"></q-icon> Quay lại
          </q-btn>
        </div>
        <div class="container text-center">
          <h1>4<q-icon name="lock" style="margin-bottom: 26px"></q-icon>3</h1>
          <h3>Bạn không có quyền truy cập</h3>
        </div>
        <div class="ghost">
          <svg class="ghost">
            <use href="#ghost"/>
          </svg>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
export default {
  name: "noPermission"
}
</script>
